import * as React from "react";

const Error = (props: any) => (
  <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
    <g fill="none" fillRule="evenodd">
      <text
        fontFamily="HelveticaNeue-Medium, Helvetica Neue"
        fontSize={17}
        fontWeight={400}
        fill="#BD0000"
        transform="translate(0 -1)"
      >
        <tspan x={4.495} y={17.25}>
          E
        </tspan>
      </text>
      <path d="M0 0h20v20H0z" />
      <path d="M.5.5v19h19V.5H.5z" stroke="#BD0000" />
    </g>
  </svg>
);

export default Error;

